import { useFetchRepairEstimateApi } from 'api/mypage/repair_estimate';
import { GlobalStateContext } from 'contexts/global_state_context';
import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { MypageRouteHelper } from 'routes/mypage';
import { useEffectSkipFirst } from 'utils/hooks';

export type RepairEstimateShowProps = {};
export const RepairEstimateShow: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const globalState = useContext(GlobalStateContext);

  const estimateApi = useFetchRepairEstimateApi(Number(id));

  useEffect(() => {
    estimateApi.execute();
  }, []);

  useEffectSkipFirst(() => {
    globalState.setLoading(estimateApi.loading);
    if (estimateApi.isSuccess() && estimateApi.response.repairEstimate.repairInfoId) {
      navigate(MypageRouteHelper.repairInfoShow(estimateApi.response.repairEstimate.repairInfoId));
    }
  }, [estimateApi.loading]);

  return <></>;
};

export default RepairEstimateShow;
